import { EmptyState, Flex, Grid } from '@pega/cosmos-react-core';
import React, { useEffect } from 'react';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';
import CustomerList from './CustomerList';
import DisplayChat from './DisplayChat';
import DisplayCustomerInfo from './DisplayCustomerInfo';

export interface CustomerDetailsProps {
  customerData: any;
  selectedCustomer: any;
  setSelectedCustomer: any;
}

const flexStyle = {
  borderLeft: '0.06rem solid #D8D8D8',
  width: '100%',
  height: '75vh',
};

const CustomerTranscriptAndDetails: React.FC<CustomerDetailsProps> = ({
  customerData,
  selectedCustomer,
  setSelectedCustomer,
}) => {
  const translate = useLocalTranslation();

  const onCustomerClick = (id: string) => {
    const customer = customerData?.find((item: any) => id === item?.customerId);
    setSelectedCustomer(customer);
  };

  useEffect(() => {
    if (selectedCustomer) {
      onCustomerClick(selectedCustomer?.customerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData]);

  return (
    <>
      {customerData?.length > 0 ? (
        <Grid
          container={{
            cols: 'repeat(1, 30% 70%)',
          }}
          style={{ width: '100%', height: '100%' }}
        >
          <CustomerList
            customerData={customerData}
            onCustomerClick={onCustomerClick}
            selectedCustomer={selectedCustomer}
          />
          <Flex style={flexStyle}>
            {selectedCustomer && Object.keys(selectedCustomer).length > 0 && (
              <Grid
                container={{
                  cols: 'repeat(1, 35% 65%)',
                }}
                style={{ width: '100%', height: '100%' }}
              >
                <DisplayCustomerInfo customerData={selectedCustomer} />
                <DisplayChat messages={selectedCustomer.messages} />
              </Grid>
            )}
          </Flex>
        </Grid>
      ) : (
        <EmptyState message={translate('no_customers_present')} />
      )}
    </>
  );
};

export default CustomerTranscriptAndDetails;
